const Style = {
  base: 'max-w-full',
};

export default Style;
